import React, { FC } from 'react';
import { ComponentRendering, Text } from '@sitecore-jss/sitecore-jss-react';
import ActionSection from './components/actionSection';
import BackToTop from './components/backToTop';
import LinksAccordion from './components/linksAccordion';
import Navigation from './components/navigation';
import SocialMedia from './components/socialMedia';
import { FooterModel } from './models/footer.model';
import { FooterProps } from './types/footer.types';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import Picture from '../@shared/picture';
import AnalyticsVisibleEvent from '../@shared/analyticsVisibleEvent';

const Footer: FC<FooterProps> = (props) => {
  const model = new FooterModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <AnalyticsVisibleEvent rendering={props?.rendering as ComponentRendering} title="Footer" template="Footer">
      {!model.hideSocialMedia && model.socialLinks && <SocialMedia fields={model.socialLinks} sitecoreContext={props?.sitecoreContext} />}
      <div className={model.hideSocialMedia ? 'footer footer__border' : 'footer'}>
        <div className="footer-content">
          <div className="footer__columns">
            {model.actionSection && <ActionSection field={model.actionSection} />}
            {model.footerSections?.map((item) => (
              <LinksAccordion key={item?.id} fields={item?.fields?.footerLinks} />
            ))}
          </div>
          <div className="footer__logo">
            <div className="footer__text">
              <Navigation fields={model.navigationSection} />
              {model.copyrightText && <Text tag="p" field={model.copyrightText} className="footer__copyright-text" />}
            </div>
            <Picture
              editorialImageProps={{
                desktopImage: model.logoImage,
                mobileImage: model.mobileLogoImage,
                desktopTransformation: 'Size200',
                mobileTransformation: 'Size200',
              }}
            />
          </div>
          {model.backToTopText && <BackToTop field={model.backToTopText} />}
        </div>
      </div>
    </AnalyticsVisibleEvent>
  );
};

export default Footer;
